import { RemoteVideoTrack, RemoteAudioTrack } from "twilio-video";
import { useCallback, useState } from "react";

export function useTracks(
  videoRef: React.RefObject<HTMLVideoElement>,
  audioRef: React.RefObject<HTMLAudioElement>
) {
  const [vTrack, setVTrack] = useState<RemoteVideoTrack>();
  const [aTrack, setATrack] = useState<RemoteAudioTrack>();

  const setVideoTrack = useCallback(
    function (newValue?: RemoteVideoTrack) {
      if (videoRef.current) {
        // https://github.com/twilio/twilio-video.js/issues/1528#issuecomment-887657118
        if (vTrack) {
          const elements = vTrack.detach();
          elements?.forEach(el => {
            el.srcObject = null;
          });
        }

        if (newValue?.kind === "video") {
          if (videoRef.current) {
            newValue.attach(videoRef.current);
          }
        }
        
        setVTrack(newValue);
      }
    },
    [videoRef, vTrack]
  );

  const setAudioTrack = useCallback(
    function (newValue?: RemoteAudioTrack) {
      if (audioRef.current) {
        // https://github.com/twilio/twilio-video.js/issues/1528#issuecomment-887657118
        if (aTrack) {
          const elements = aTrack.detach();
          elements?.forEach(el => {
            el.srcObject = null;
          });
        }

        if (newValue?.kind === "audio") {
          if (audioRef.current) {
            newValue.attach(audioRef.current);
          }
        }

        setATrack(newValue);
      }
    },
    [audioRef, aTrack]
  );
  return {
    setVideoTrack,
    setAudioTrack,
    aTrack,
    vTrack,
  };
}
